var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrisisLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.402 12.1949C12.5018 13.2626 11.1832 12.9694 11.1832 12.9694C9.29959 12.6973 7.60452 11.232 7.60452 11.232C4.46512 8.51083 4.44419 6.68972 4.44419 6.68972C4.04653 4.97328 5.28136 3.94761 5.28136 3.94761C5.78367 3.50803 6.28597 3.86388 6.28597 3.86388L7.70917 5.26633C8.33705 5.91523 7.68824 6.4804 7.68824 6.4804L7.03943 7.1293C7.96032 9.20159 10.2835 10.4157 10.2835 10.4157L11.1207 9.57837C11.6646 9.24345 12.0204 9.62023 12.0204 9.62023L13.4436 11.0227C14.0298 11.7344 13.402 12.1949 13.402 12.1949ZM16.9181 6.18735L14.9716 2.79633C14.1972 1.45667 12.7529 0.619385 11.1832 0.619385H7.29057C5.74159 0.619385 4.29768 1.45667 3.50237 2.79633L1.55573 6.18735C0.781554 7.52701 0.781554 9.20159 1.55573 10.5413L3.50237 13.9323C4.27654 15.2719 5.72087 16.1092 7.29057 16.1092H11.2044C12.7529 16.1092 14.1972 15.2719 14.9926 13.9323L16.9388 10.5413C17.6924 9.20159 17.6924 7.52701 16.9181 6.18735Z",
    fill: "#F4823C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrisisLine);
export default __webpack_public_path__ + "static/media/CrisisLine.bf1cb4fd.svg";
export { ForwardRef as ReactComponent };